import { useLayoutEffect, useRef, type ReactNode } from 'react'

export function PinnedCellContent({
  children,
  columnId,
  rowId,
  onWidthChange,
  measureWidth = true
}: {
  children: ReactNode
  columnId: string
  rowId: string
  onWidthChange: (columnId: string, rowId: string, width: number) => void
  measureWidth?: boolean
}) {
  const ref = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const content = ref.current
    if (!content || !measureWidth) return
    const measure = () => {
      // offsetWidth excludes the buttons' hover/press transforms.
      const width = content.offsetWidth
      if (width > 0) onWidthChange(columnId, rowId, width)
    }
    measure()
    if (typeof ResizeObserver === 'undefined') return
    const observer = new ResizeObserver(measure)
    observer.observe(content)
    return () => observer.disconnect()
  }, [columnId, rowId, onWidthChange, measureWidth])

  if (!measureWidth) return <>{children}</>

  return (
    <div
      ref={ref}
      data-slot='omni-table-pinned-content'
      className='inline-flex w-max items-center whitespace-nowrap'
    >
      {children}
    </div>
  )
}
